import React from "react";
import _ from "lodash";

const PdfShppingAddress = ({
  title,
  address1,
  address2,
  disrict,
  state,
  gst,
}) => {
  return (
    <div className="shippingaddressbox pdfpadding">
      <h2>{_.capitalize(title)}</h2>
      <p>{address1}</p>
      <p>{address2}</p>
      <p>{_.upperFirst(disrict)}</p>
      <p>{_.upperFirst(state)}</p>
      {
        gst && <p> GSTIN {gst}</p>
      }
      
    </div>
  );
};

export default PdfShppingAddress;
